import _ from "lodash"

const RNBootSplash = {
  hide: _.noop
}

export default RNBootSplash
